export * from './data-filter-name.pipe';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/dataFilterName/index.ts